import { Button, type ButtonProps } from "@/components/ui/Button";

export interface SaveChangesButtonProps extends ButtonProps {
  /** True when the form differs from the last loaded values. */
  isDirty: boolean;
}

/**
 * Persist-edit save control. Stays disabled until `isDirty` is true.
 * Default label is Save changes; pass children for Save case, Save notes, and similar.
 */
export function SaveChangesButton({
  isDirty,
  disabled,
  children = "Save changes",
  ...rest
}: SaveChangesButtonProps) {
  return (
    <Button {...rest} disabled={disabled || !isDirty}>
      {children}
    </Button>
  );
}
